import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';
// components/BottomSheet/BottomSheet.js
import React, { useEffect, useState } from 'react';

import sampleImage from '../../assets/sample-image.webp';
import '../styles/highlight.css';

const BottomSheet = ({ isOpen, onClose, onBookmark, projectData, announcement, proceedAction }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);


  const defaultAvatar = sampleImage;
  const photoUrls = Array.isArray(projectData?.photos) && projectData.photos.length > 0
    ? projectData.photos
      .map((photo) => (typeof photo === 'string' ? photo : photo?.url || photo?.image || photo?.src))
      .filter(Boolean)
    : [];

  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);

  useEffect(() => {
    if (selectedPhotoIndex >= photoUrls.length) {
      setSelectedPhotoIndex(0);
    }
  }, [photoUrls.length, selectedPhotoIndex]);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.body.style.overflow = 'hidden';
    } else {
      setIsVisible(false);
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300); // Match animation duration
  };

  if (!isOpen) return null;

  console.log('projectData:', projectData);

  return (
    <>
      <div
        className={`bottom-sheet-overlay ${isVisible ? 'visible' : ''}`}
        onClick={handleClose}
      />
      <div className={`bottom-sheet ${isVisible ? 'visible' : ''}`}>
        <div className="bottom-sheet-handle" onClick={handleClose}>
          <div className="handle-bar" />
        </div>

        <div className="bottom-sheet-content">
          {/* Header */}
          <div className="sheet-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h2 className="sheet-title" style={{ margin: 0 }}>Project Highlights</h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <button className="bookmark-button" title="Bookmark project" onClick={onBookmark} style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: 0, padding: 0 }}>
                {/* <img src={iconBookmark} alt="Bookmark" style={{ width: 28, height: 28, display: 'block' }} /> */}
                <FontAwesomeIcon icon={faBookmark} className={`bookmark-fa-icon${isBookmarked ? ' bookmarked' : ''}`} style={{ transition: 'color 0.2s' }} />
              </button>
              <button className="close-button" onClick={handleClose}>×</button>
            </div>
          </div>

          {/* Bookmark Section */}
          {/* <div className="bookmark-section">
            <div className="bookmark-icon">🔖</div>
            <p className="bookmark-text">
              Bookmark to get instant notification on this project.
            </p>
          </div> */}

          {/* Divider */}
          {/* <hr className="divider" /> */}

          {/* Project Photos Section */}
          <div className="photos-section">
            <h3 className="section-title">Project Photos</h3>

            <div className="photo-preview" aria-live="polite">
              <div className="photo-preview-placeholder">
                <img
                  src={photoUrls.length > 0 ? photoUrls[selectedPhotoIndex] : (projectData.cover || defaultAvatar)}
                  alt={photoUrls.length > 0 ? `Project preview ${selectedPhotoIndex + 1}` : (projectData.cover ? 'Project Cover Image' : 'Default Project Avatar')}
                  className="photo-preview-image"
                />
              </div>
            </div>

            <div className="photo-list" role="list" aria-label="Project photos" style={{ height: photoUrls.length === 0 ? 0 : undefined }}>
              {photoUrls.length > 0 && photoUrls.map((url, index) => (
                <button
                  key={`${url}-${index}`}
                  type="button"
                  className={`photo-card ${selectedPhotoIndex === index ? 'active' : ''}`}
                  role="listitem"
                  onClick={() => setSelectedPhotoIndex(index)}
                >
                  <img
                    src={url}
                    alt={`Project photo ${index + 1}`}
                    className="photo-image"
                  />
                </button>
              ))}
            </div>
          </div>

          {/* Divider */}
          {/* <hr className="divider" /> */}

          {/* Additional Information Section */}
          <div className="additional-info-section">
            <h3 className="section-title">Additional Information</h3>
            {announcement ? (
              <div className="announcement-card">
                {announcement.title && (
                  <p className="announcement-title" style={{ fontWeight: 600, marginBottom: 8 }}>{announcement.title}</p>
                )}
                <p className="announcement-text">
                  {(announcement.description !== undefined && announcement.description !== null)
                    ? announcement.description
                    : (announcement.announcement !== undefined && announcement.announcement !== null)
                      ? announcement.announcement
                      : (announcement.text !== undefined && announcement.text !== null)
                        ? announcement.text
                        : 'No announcement details.'}
                </p>
                {announcement.date && (
                  <p className="announcement-date">{announcement.date}</p>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default BottomSheet;